import ConfirmationModal from 'components/V2/ConfirmationModal';
import React from 'react';
import { connect } from 'react-redux';
import { dismissSchedulingConflict } from 'redux/ducks/Modals';

// Raised when the API refuses a save that would leave an athletic trainer in two
// places at once: a shift moved onto another commitment (GO4-1808), or one AT's
// hours edited into the same clash from the job modal. Both edits happen in
// different scenes, so this is mounted once next to the flash rather than in
// each of them.
//
// A flash was the wrong channel for it — it self-dismisses after ten seconds,
// and this is a refusal the EO has to act on.
export const SchedulingConflictModal = ({ conflict, onDismiss }) => (
  <ConfirmationModal
    isOpen={!!conflict}
    toggle={onDismiss}
    onSave={onDismiss}
    title="Scheduling Conflict"
    confirmText="Got it"
    htmlBody
    body={
      <>
        <p>{conflict?.message}</p>
        <p>
          <small>
            {conflict?.context === 'job'
              ? 'Nothing was saved — the hours are still the ones the athletic trainer confirmed.'
              : 'Nothing was saved — the shift keeps its current times.'}
          </small>
        </p>
      </>
    }
  />
);

const mapStateToProps = (state) => ({
  conflict: state.modals.schedulingConflict,
});

const mapDispatchToProps = (dispatch) => ({
  onDismiss: () => dispatch(dismissSchedulingConflict()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SchedulingConflictModal);
